<template>
  <div class="footer">
    <div class="footer-body">
      <div class="container">
        <el-row>
          <el-col :xs="24" :md="6">
            <div class="ft-logo img">
              <img
                :src="require('@/assets/download.png')"
                fit="contain"
                style="margin-top: 0"
              />
            </div>
            <div class="copy-right">
              <p>版权所有©2015-2024 联创智云</p>
              <p>
                <router-link to="https://beian.miit.gov.cn">
                  闽ICP备16008014号-1
                </router-link>
              </p>
            </div>
          </el-col>

          <el-col :xs="24" :md="6">
            <p class="ft-title hidden-xs-only" tag="b">服务热线</p>
            <p class="hottel" size="large">0591-87832189</p>
            <p>工作时间:(09:00-18:00)</p>
            <p>咨询邮箱:info@lczyfz.com</p>
          </el-col>

          <el-col :xs="24" :md="8">
            <p class="ft-title hidden-xs-only" tag="b">联系我们</p>
            <p class="mb10">总部地址:福州市工业路523号福州大学国家大学科技园创业楼5层</p>
            <p class="mb10">
              研发中心地址:福州大学国家大学科技园（旗山校区）8号楼数字福建技术研发大楼A口4层
            </p>
          </el-col>

          <el-col :md="4" :xs="0" class="hidden-xs-only">
            <p class="ft-title" tag="b">关注公众号</p>
            <div class="footer-ewm">
              <img :src="require('@/assets/download.jpg')" class="img-responsive" />
            </div>
            <p class="ft-1">扫一扫关注我们</p>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutFooter'
}
</script>

<style lang="scss" scoped>
.footer {
  background: url(@/assets/bg-ft.jpg) no-repeat;
  background-size: 100%;
  box-sizing: border-box;

  .footer-body {
    background: rgba(9, 14, 28, 0.75);
    padding-top: 40px;
    padding-bottom: 20px;
    position: relative;
  }
  .container {
    padding: 0 15px;
    margin: 0 auto;
    @media (min-width: 768px) {
      width: 750px;
    }
    @media (min-width: 992px) {
      width: 970px;
    }
    @media (min-width: 1200px) {
      width: 1140px;
    }
    .el-row {
      position: relative;
      margin-right: -15px;
      margin-left: -15px;

      .el-col {
        float: left;
        position: relative;
        min-height: 1px;
        padding-right: 15px;
        padding-left: 15px;

        .ft-title {
          color: #fff;
          font-size: 16px;
          height: 22.844px;
          margin-bottom: 48px;
          margin-top: 9px;
          text-align: left;
        }
        .mb10 {
          margin-bottom: 10px;
        }
        .hottel {
          color: #faf4f4;
          margin-bottom: 10px;
          text-align: left;
          display: block;
          height: 20px;
          line-height: 20px;
        }
        p a {
          color: #faf4f4;
          text-decoration: none;
        }
        p {
          text-align: left;
          position: relative;
          font-size: 14px;
          color: #faf4f4;
          line-height: 22px;
          text-indent: 0;
        }
        .copy-right {
          color: #fff;
          width: 200px;
          margin: 15px auto;
        }
        .copy-right p {
          margin-bottom: 5px;
        }
        .ft-logo {
          padding-top: 1px;
          margin: 0 auto;
          display: block;
          max-width: 100%;
          height: auto;

          img {
            vertical-align: middle;
            overflow-clip-margin: content-box;
            overflow: clip;
          }
        }
        .footer-ewm {
          margin-bottom: 7px;
          width: 101px;
          height: 101px;
          overflow: hidden;

          img {
            vertical-align: middle;
          }

          .img-responsive {
            display: block;
            max-width: 100%;
            height: auto;
          }
        }
      }
    }
  }
}
</style>
